var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-wrapper"},[_c('div',{staticClass:"item-container",class:{ 'blue-color': _vm.active }},[_c(_vm.iconComponent,{tag:"component"}),_c('span',{staticClass:"header-item-label"},[_vm._v(_vm._s(_vm.$t(_vm.name)))])],1),(!_vm.isLast)?_c('div',{staticClass:"connection-line"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }